import { FC } from 'react';

type Props = {
	className?: string;
};

const InternetIcon: FC<Props> = ({ className }) => {
	return (
		<svg
			width='20'
			height='20'
			viewBox='0 0 20 20'
			xmlns='http://www.w3.org/2000/svg'
			fill='none'
			stroke='#2B2B2B'
			className={className}>
			<path
				d='M9.99984 17.9997C14.418 17.9997 17.9997 14.418 17.9997 9.99984C17.9997 5.58165 14.418 2 9.99984 2C5.58165 2 2 5.58165 2 9.99984C2 14.418 5.58165 17.9997 9.99984 17.9997Z'
				stroke='inherit'
				strokeWidth='1.25'
			/>
			<path
				d='M10.0007 17.9997C11.768 17.9997 13.2007 14.418 13.2007 9.99984C13.2007 5.58165 11.768 2 10.0007 2C8.23344 2 6.80078 5.58165 6.80078 9.99984C6.80078 14.418 8.23344 17.9997 10.0007 17.9997Z'
				stroke='inherit'
				strokeWidth='1.25'
			/>
			<path
				d='M2 10H17.9997'
				stroke='inherit'
				strokeWidth='1.25'
				strokeLinecap='round'
				strokeLinejoin='round'
			/>
		</svg>
	);
};

export default InternetIcon;
